import React, { useState } from 'react';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../services/firebase';
import { useAuth } from '../contexts/AuthContext';
import Logo from './Logo';

export default function WelcomeScreen({ onComplete }) {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (currentUser?.uid) {
      await setDoc(
        doc(db, 'users', currentUser.uid),
        { name, firstLoginCompleted: true },
        { merge: true }
      );
    }
    setLoading(false);
    onComplete();
  };

  return (
    <div
      className="welcome-screen"
      tabIndex={-1}
      style={{
        maxWidth: 420,
        margin: '80px auto',
        padding: 32,
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 2px 24px rgba(0,0,0,0.10)',
        textAlign: 'center',
        userSelect: 'none',
        outline: 'none',
      }}
    >
      <Logo height={100} />
      <h2 style={{ color: '#1B365D', fontWeight: 'bold', marginTop: 24, marginBottom: 8 }}>Bem-vindo ao Habitop!</h2>
      <p style={{ color: '#444', fontSize: 18, marginBottom: 18 }}>
        Agora você tem uma ferramenta completa para transformar sua rotina e conquistar seus sonhos!
      </p>
      <ul style={{ textAlign: 'left', margin: '0 auto 18px auto', maxWidth: 340, color: '#555', fontSize: 16, lineHeight: 1.7 }}>
        <li>Defina e acompanhe <b>metas</b> e <b>objetivos</b> pessoais</li>
        <li>Registre e monitore seus <b>hábitos diários</b></li>
        <li>Visualize <b>estatísticas</b> e identifique padrões de comportamento</li>
        <li>Receba <b>recomendações</b> e dicas personalizadas</li>
             <li>Obtenha <b>relatórios</b> e gráficos do seu progresso</li>
        <li>Participe de <b>desafios</b> e celebre conquistas</li>
        <li><b>Organize</b> sua rotina de forma simples e intuitiva</li>
        <li><b>Personalize</b> as cores da ferramenta com a sua favorita!</li>
      </ul>
      <p style={{ color: '#1B365D', fontWeight: 'bold', fontSize: 16, marginBottom: 28 }}>
        O Habitop está com você em cada passo. Comece agora a trilhar o caminho do seu sucesso!
      </p>
      <form onSubmit={handleSubmit} style={{ marginTop: 12 }}>
        <label style={{ display: 'block', marginBottom: 16, fontWeight: 500, color: '#1B365D', userSelect: 'auto' }}>
          Qual seu nome?
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            required
            style={{ width: '100%', padding: 10, marginTop: 8, borderRadius: 6, border: '1px solid #ccc', fontSize: 16, userSelect: 'auto' }}
          />
        </label>
        <button type="submit" disabled={loading || !name} style={{ padding: '12px 32px', border: 'none', borderRadius: 6, background: '#4f8cff', color: '#fff', fontWeight: 'bold', fontSize: 16, cursor: 'pointer', boxShadow: '0 2px 8px rgba(79,140,255,0.08)' }}>
          {loading ? 'Salvando...' : 'Começar'}
        </button>
      </form>
    </div>
  );
} 